import React, { useReducer } from 'react'
import DirectoryContext from './context'
import {
  directoryReducer,
  SET_ASSETS,
  APPEND_ASSETS,
  SET_FILTERS,
  SET_SHOW_MAP,
} from './reducer'
import queryString from 'query-string'

const DirectoryProvider = (props) => {
  const [state, dispatch] = useReducer(directoryReducer, {
    assets: [],
    filters: {
      page: 1,
    },
    showMap: true,
  })

  const getAssets = (type) => {
    let path = ''
    const query = queryString.stringify(state.filters, {
      arrayFormat: 'bracket',
    })

    if (type === 'assets') {
      path = `/assets.json?${query}`
    } else if (type === 'municipal') {
      path = `/municipal-support.json?${query}`
    }

    fetch(path)
      .then((response) => response.json())
      .then((data) => {
        if (state.filters.page === 1) {
          dispatch({
            type: SET_ASSETS,
            assets: data,
          })
        } else {
          dispatch({
            type: APPEND_ASSETS,
            assets: data,
          })
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const updateFilters = (filters) => {
    dispatch({
      type: SET_FILTERS,
      filters,
    })
  }

  const toggleMap = () => {
    dispatch({
      type: SET_SHOW_MAP,
      showMap: !state.showMap,
    })
  }

  return (
    <DirectoryContext.Provider
      value={{
        assets: state.assets,
        filters: state.filters,
        showMap: state.showMap,
        getAssets,
        updateFilters,
        toggleMap,
      }}
    >
      {props.children}
    </DirectoryContext.Provider>
  )
}

export default DirectoryProvider
